import { useEffect } from 'react'
import { io } from 'socket.io-client'
import toast from 'react-hot-toast'

let socket = null
let connectionAttempts = 0
const MAX_RECONNECT_ATTEMPTS = 10

export default function NotificationSystem() {
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token && !socket) {
      // Use the same backend URL as axios
      const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      const backendUrl = isLocalhost 
        ? 'http://localhost:5000' 
        : 'https://marketbooksolutionbackendmain.onrender.com'

      // Socket.io configuration with improved timeout and reconnection handling
      socket = io(backendUrl, {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
        timeout: 30000, // 30 second connection timeout instead of default 20
        connectTimeout: 30000,
        ackTimeout: 30000,
        retryInterval: 1000
      })

      socket.on('notification', (notification) => {
        toast.success(notification.message, {
          duration: 5000,
          position: 'top-right',
        })
      })

      socket.on('connect', () => {
        console.log('[NotificationSystem] Socket connected successfully:', socket.id)
        connectionAttempts = 0
      })

      socket.on('connect_error', (error) => {
        connectionAttempts++
        console.error('[NotificationSystem] Socket connection error:', error.message, `(Attempt ${connectionAttempts}/${MAX_RECONNECT_ATTEMPTS})`)
        if (connectionAttempts >= MAX_RECONNECT_ATTEMPTS) {
          console.warn('[NotificationSystem] Max reconnection attempts reached')
          // Clear socket to allow manual restart
          socket = null
        }
      })

      socket.on('disconnect', (reason) => {
        console.log('[NotificationSystem] Socket disconnected:', reason)
        if (reason === 'io server disconnect') {
          // Server disconnected, try to reconnect
          socket.connect()
        }
      })

      socket.on('error', (error) => {
        console.error('[NotificationSystem] Socket error:', error)
      })
    }

    return () => {
      if (socket) {
        socket.disconnect()
        socket = null
        connectionAttempts = 0
      }
    }
  }, [])

  return null
}